var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-wrap',{attrs:{"preview-data":_vm.previewData}},[_c('div',{staticClass:"info-container"},[_vm._v(" 暂不支持."+_vm._s(_vm.previewData.fileType)+"类型文件在线预览，请点击下载按钮下载后查看 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }